module.exports = __webpack_public_path__ + "static/media/Lydia.120ec153.jpeg";